import httpService from "./httpService"

export async function getAdminCreateBlogMoudleFormHtml(moduleTypeId) {
    const { data } = await httpService.get(`/administration/blogmanagement/getcreateblogpostmoduleform?moduleType=${moduleTypeId}`);
    //console.log("getAdminCreateBlogMoudleFormHtml", data);
    return data;
}

export async function getAdminUpdateBlogMoudleFormHtml(moduleId) {
    const { data } = await httpService.get(`/administration/blogmanagement/getupdateblogpostmoduleform?blogPostModuleId=${moduleId}`);
    //console.log("getAdminUpdateBlogMoudleFormHtml", data);
    return data;
}

export async function submitBlogModuleForm(formData) {
    //console.log("submitBlogModuleForm", formData);
    const { data } = await httpService.post("/administration/blogmanagement/submitblogpostmoduleform", formData);
    //console.log("submitBlogModuleForm Response", data);
    return data;
}

export async function deleteBlogModule(id) {
    const { data } = await httpService.delete("/administration/blogmanagement/deleteblogmodule", { id });
    //console.log("deleteBlogModule", data);
    return data;
}

export async function getBlogPostModuleImage(id) {
    const { data } = await httpService.get("/administration/blogmanagement/getblogpostmoduleimage", { id });
    //console.log("getBlogPostModouleImage", data);
    return data;
}

export async function updateBlogPostModuleImage(image) {
    const { data } = await httpService.put("/administration/blogmanagement/updateblogpostmoduleimage", { image });
    //console.log("updateBlogPostModuleImage", data);
    return data;
}

export async function uploadBlogPostModuleImage(image, blogPostId, imageAlt) {
    const formData = new FormData();
    formData.append("file", image);
    formData.append("blogPostId", blogPostId);
    formData.append("imageAlt", imageAlt);

    return $.ajax(
        {
            url: "/administration/blogmanagement/uploadblogpostmoduleimage",
            data: formData,
            processData: false,
            contentType: false,
            type: "POST",
            success: function (data) {
                console.log("Image Upload Response", data);
                return data;
            }
        }
    );
}